import React from 'react';
import AnimatedElement from '../components/AnimatedElement.js';
import PlayIcon from '../components/PlayIcon.js';

const IntroSection = () => (
    <section id="intro" className="h-screen w-screen flex-shrink-0 flex flex-col items-center justify-center p-8 md:p-16 bg-brand-black text-brand-cream overflow-hidden">
        <div className="max-w-5xl w-full space-y-8 md:space-y-16">
            <AnimatedElement>
                {/* <p className="text-lg md:text-xl font-bold mb-4 text-brand-peach">Hossein Basir</p> */}
                <span className="block justify-center" style={{ fontFamily: 'pinar', color: '#FFFFFF',fontSize: "clamp(24px, 6vw, 60px)", lineHeight: "1.4"}} dir="rtl">روزی استارتاپ بودیم، امروز طراح مسیر رشد <a style={{ fontFamily: 'pinar', color: '#ff2a3f' ,fontSize: "clamp(24px, 6vw, 60px)"}}>استارتاپ‌ها</a> و <a style={{ fontFamily: 'pinar', color: '#ff2a3f' ,fontSize: "clamp(24px, 6vw, 60px)"}}>برندهای</a> در حال تحولیم</span>
            </AnimatedElement>
            <div className="grid grid-cols-1 md:grid-cols-1 gap-8 text-base md:text-lg">
               
            <AnimatedElement
  delay={0.9}
  className="text-right px-8 text-white text-base sm:text-lg md:text-xl leading-relaxed"
  style={{
     textAlign: "justify", textAlignLast: "right", direction: "rtl",
    textJustify: "inter-word",
  }}
> 
    <a  style={{
      fontFamily: 'pinar',
     textAlign: "justify", textAlignLast: "right", direction: "rtl"
  }}>
  برند سازی فرایندی است برای جایگاهی معنادار و ماندگار در ذهن مخاطب. در بازاری که رقابت شدید است، برندهایی که تنها بر محصول تکیه می‌کنند، سریع‌تر از آنچه تصور می‌کنند ناپدید می‌شوند. تمایز واقعی زمانی شکل می‌گیرد که برند معنا، ارزش و هویتی فراتر از محصول ایجاد کند.
  </a>
</AnimatedElement>
            </div>
        </div>
    </section>
);

export default IntroSection;

